<template>
  <div>
    <CreateServerMenu ref="CreateServerMenu"></CreateServerMenu>
    <Card shadow>
      <Layout>
        <sider :style="{background: '#fff'}">
          <ul>
            <li :class="{ 'form-item': true, 'form-item-active': currentFormType === item.value }"
                v-on:click="currentFormType = item.value; currentFormTypeStep = index" v-for="(item, index) in formTypeList" :key="'formType_' + index">
              <span>{{ item.label }}</span><span v-if="item.required" style="color: #ed4014"> *</span>
            </li>
          </ul>
        </sider>
        <Content :style="{background: '#fff'}">
          <Form :model="changeForm" ref="changeForm" :rules="changeRule" label-position="right">
            <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
            <div v-show="currentFormType === 'info'">
              <Alert show-icon>请提供实例的主机名，欲部署的可用区域。</Alert>
              <Layout>
                <Content :style="{background: '#fff'}" style="min-width: 130px">
                  <FormItem prop="name" label="实例名称">
                    <Input v-model="changeForm.name"/>
                  </FormItem>
                  <FormItem prop="availability_zone" label="可用域">
                    <Select v-model="changeForm.availability_zone" transfer>
                      <Option v-for="item in availabilityZoneList" :key="item.zoneName" :value="item.zoneName">{{ item.zoneName }}</Option>
                    </Select>
                  </FormItem>
                </Content>
                <sider :style="{background: '#fff', padding: '20px'}" :width="300">
                  <Quota module="instances" content="实例配额" ref="Quota"></Quota>
                </sider>
              </Layout>
            </div>
            <div v-show="currentFormType === 'source'">
              <Alert show-icon>
                <span>实例的源是用来创建实例的模板。 可以使用一个镜像、一个实例的快照（镜像快照）、 一个卷或一个卷快照（如果启用这个功能）。</span>
                <span>您也可以通过创建一个新卷来选择使用具有持久性的存储。</span>
              </Alert>
              <FormItem prop="source_type" label="源">
                <Select v-model="changeForm.source_type" placeholder="">
                  <Option value="image" key="image">镜像</Option>
                  <Option value="volume" key="volume">卷</Option>
                  <Option value="snapshot" key="snapshot">卷快照</Option>
                  <Option value="server_snapshot" key="server_snapshot" :disabled="true">实例快照</Option>
                </Select>
              </FormItem>
              <div v-if="changeForm.source_type === 'image'">
                <div class="req-form">
                  <p style="color: #19be6b">已选择的镜像</p>
                  <Table
                    size="small"
                    no-data-text="从以下可选项中选择一个镜像"
                    ref="selectedImageTable"
                    :data="selected_image_data"
                    :columns="selected_image_columns">
                  </Table>
                  <br/>
                  <p style="color: #108ee9">可选镜像 <Badge :count="imageList.length" type="normal"></Badge>：</p>
                  <Table
                    size="small"
                    :loading="imageOptionalLoading"
                    ref="imageOptionalTable"
                    :height="imageList.length > 7 ? 300 : 0"
                    :data="imageList"
                    :columns="image_optional_columns">
                  </Table>
                </div>
              </div>
              <div v-else-if="changeForm.source_type === 'volume'">
                <div class="req-form">
                  <p style="color: #19be6b">已选择的卷</p>
                  <Table
                    size="small"
                    no-data-text="从以下可选项中选择一个卷"
                    ref="selectedVolumeTable"
                    :data="selected_volume_data"
                    :columns="selected_volume_columns">
                  </Table>
                  <br/>
                  <p style="color: #108ee9">可选卷 <Badge :count="volumeList.length" type="normal"></Badge>：</p>
                  <Table
                    size="small"
                    :loading="volumeOptionalLoading"
                    ref="volumeOptionalTable"
                    :height="volumeList.length > 7 ? 300 : 0"
                    :data="volumeList"
                    :columns="volume_optional_columns">
                  </Table>
                </div>
              </div>
              <div v-else-if="changeForm.source_type === 'snapshot'">
                <div class="req-form">
                  <p style="color: #19be6b">已选择的卷快照</p>
                  <Table
                    size="small"
                    no-data-text="从以下可选项中选择一个卷快照"
                    ref="selectedVolumeSnapshotTable"
                    :data="selected_volume_snapshot_data"
                    :columns="selected_volume_snapshot_columns">
                  </Table>
                  <br/>
                  <p style="color: #108ee9">可选卷快照 <Badge :count="volumeSnapshotList.length" type="normal"></Badge>：</p>
                  <Table
                    size="small"
                    :loading="volumeSnapshotOptionalLoading"
                    ref="volumeSnapshotOptionalTable"
                    :height="volumeSnapshotList.length > 7 ? 300 : 0"
                    :data="volumeSnapshotList"
                    :columns="volume_snapshot_optional_columns">
                  </Table>
                </div>
              </div>
              <div v-if="changeForm.source_type === 'image' || changeForm.source_type === 'server_snapshot'" style="margin-top: 5px">
                <FormItem prop="create_new_volume" label="创建新卷">
                  <i-switch v-model="changeForm.create_new_volume">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </div>
              <div v-if="changeForm.create_new_volume === true && changeForm.source_type === 'image' || changeForm.source_type === 'server_snapshot'">
                <FormItem prop="volume_size" label="新卷大小" v-if="changeForm.create_new_volume === true">
                  <InputNumber :min="1" v-model="changeForm.volume_size"></InputNumber><span> (GB)</span>
                </FormItem>
              </div>
              <div v-if="changeForm.create_new_volume === true || changeForm.source_type === 'volume' || changeForm.source_type === 'snapshot'">
                <FormItem prop="delete_on_termination" label="删除实例时删除卷">
                  <i-switch v-model="changeForm.delete_on_termination">
                    <span slot="open">是</span>
                    <span slot="close">否</span>
                  </i-switch>
                </FormItem>
              </div>
            </div>
            <div v-show="currentFormType === 'flavor'">
              <Alert show-icon>
                <span>类型管理实例的计算、内存和存储容量的大小。</span>
              </Alert>
              <p style="color: #19be6b">已选择的实例类型</p>
              <Table
                size="small"
                no-data-text="从以下可选项中选择一个实例类型"
                ref="selectedFlavorTable"
                :data="selected_flavor_data"
                :columns="selected_flavor_columns">
              </Table>
              <br/>
              <p style="color: #108ee9">可选实例类型 <Badge :count="flavorList.length" type="normal"></Badge>：</p>
              <Table
                size="small"
                :loading="flavorOptionalLoading"
                ref="flavorOptionalTable"
                :height="flavorList.length > 7 ? 300 : 0"
                :data="flavorList"
                :columns="flavor_optional_columns">
              </Table>
            </div>
            <div v-show="currentFormType === 'network'">
              <Alert show-icon>
                <span>在云中，网络为实例提供通信通道。</span>
              </Alert>
              <p style="color: #19be6b">已选择的网络</p>
              <Table
                size="small"
                no-data-text="从以下可选项中选择一个或多个网络"
                ref="selectedNetworkTable"
                :data="selected_network_data"
                :columns="selected_network_columns">
              </Table>
              <br/>
              <p style="color: #108ee9">可选网络 <Badge :count="networkList.length" type="normal"></Badge>：</p>
              <Table
                size="small"
                :loading="networkOptionalLoading"
                ref="networkOptionalTable"
                :height="networkList.length > 7 ? 300 : 0"
                :data="networkList"
                :columns="network_optional_columns">
              </Table>
            </div>
            <div v-show="currentFormType === 'port'">
              <Alert show-icon>
                <span>端口（网络接口）为您的实例提供了额外的通信渠道。您可以选择端口而非网络或者二者都选</span>
              </Alert>
              <p style="color: #19be6b">已选择的端口</p>
              <Table
                size="small"
                no-data-text="从以下可选项中选择一个或多个端口"
                ref="selectedPortTable"
                :data="selected_port_data"
                :columns="selected_port_columns">
              </Table>
              <br/>
              <p style="color: #108ee9">可选端口 <Badge :count="portList.length" type="normal"></Badge>：</p>
              <Table
                size="small"
                :loading="portOptionalLoading"
                ref="portOptionalTable"
                :height="portList.length > 7 ? 300 : 0"
                :data="portList"
                :columns="port_optional_columns">
              </Table>
            </div>
            <div v-show="currentFormType === 'security_group'">
              <Alert show-icon>
                <span>要在其中启动实例的安全组。</span>
              </Alert>
              <p style="color: #19be6b">已选择的安全组</p>
              <Table
                size="small"
                no-data-text="从以下可选项中选择一个或多个安全组"
                ref="selectedSecurityGroupTable"
                :data="selected_security_group_data"
                :columns="selected_security_group_columns">
              </Table>
              <br/>
              <p style="color: #108ee9">可选安全组 <Badge :count="securityGroupList.length" type="normal"></Badge>：</p>
              <Table
                size="small"
                :loading="securityGroupOptionalLoading"
                ref="securityGroupOptionalTable"
                :height="securityGroupList.length > 7 ? 300 : 0"
                :data="securityGroupList"
                :columns="security_group_optional_columns">
              </Table>
            </div>
            <div v-show="currentFormType === 'keypair'">
              <Alert show-icon>
                <span>密钥对允许您SSH到您新创建的实例。</span>
              </Alert>
              <p style="color: #19be6b">已选择的密钥对</p>
              <Table
                size="small"
                no-data-text="从以下可选项中选择一个密钥对"
                ref="selectedKeyPairTable"
                :data="selected_key_pair_data"
                :columns="selected_key_pair_columns">
              </Table>
              <br/>
              <p style="color: #108ee9">可选密钥对 <Badge :count="keyPairList.length" type="normal"></Badge>：</p>
              <Table
                size="small"
                :loading="keyPairOptionalLoading"
                ref="keyPairOptionalTable"
                :height="keyPairList.length > 7 ? 300 : 0"
                :data="keyPairList"
                :columns="key_pair_optional_columns">
              </Table>
            </div>
          </Form>
        </Content>
      </Layout>
      <div style="text-align: right">
        <Button style="float: left" @click="$router.go(-1)" icon="md-close">取消</Button>
        <div>
          <Button type="default" style="margin-right: 8px;" v-show="currentFormTypeStep !== 0"
                  @click="currentFormType = formTypeList[currentFormTypeStep - 1].value; currentFormTypeStep = currentFormTypeStep - 1;">
            <Icon type="ios-arrow-back"></Icon>
            上一项
          </Button>
          <Button type="default" style="margin-right: 8px;" v-show="currentFormTypeStep !== formTypeList.length - 1"
                  @click="currentFormType = formTypeList[currentFormTypeStep + 1].value; currentFormTypeStep = currentFormTypeStep + 1;">
            下一项
            <Icon type="ios-arrow-forward"></Icon>
          </Button>
          <Button type="primary" @click="changeSubmit" icon="md-cloud-upload" :loading="changeLoading">开始创建</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudAllFlavor } from '@/api/private-cloud/flavor'
import { getPrivateCloudAllImage } from '@/api/private-cloud/image'
import { getPrivateCloudAllVolume } from '@/api/private-cloud/volume'
import { getPrivateCloudAllVolumeSnapshot } from '@/api/private-cloud/volume-snapshot'
import { getPrivateCloudAllNetwork } from '@/api/private-cloud/network'
import { getPrivateCloudAllPort } from '@/api/private-cloud/port'
import { getPrivateCloudAllSecurityGroup } from '@/api/private-cloud/security-group'
import { getPrivateCloudAllKeyPair } from '@/api/private-cloud/keypair'
import { getPrivateCloudAvailabilityZones } from '@/api/private-cloud/availability-zone'
import { changePrivateCloudServer } from '@/api/private-cloud/server'
import SecurityGroupRuleList from '../net/components/security-group-rule-list'
import Quota from './components/quota'
import CreateServerMenu from './components/create-menu'

export default {
  name: 'server-create',
  components: {
    SecurityGroupRuleList,
    Quota,
    CreateServerMenu
  },
  data () {
    return {
      changeModalTitle: '创建实例',
      currentStep: 0,
      changeModal: false,
      changeLoading: false,
      errorMsgShow: false,
      errorMsg: '',
      availabilityZoneList: [],
      changeForm: {
        id: '',
        name: '',
        source_type: 'image',
        availability_zone: '',
        imageRef: '',
        create_new_volume: true,
        volume_size: 5,
        delete_on_termination: false,
        flavor: ''
      },
      changeRule: {
        name: [
          { required: true, message: '实例名称不能为空', trigger: 'blur' }
        ],
        availability_zone: [
          { required: true, message: '请选择可用域', trigger: 'change' }
        ],
        source_type: [
          { required: true, message: '源不能为空', trigger: 'change' }
        ],
        flavor: [
          { required: true, message: '实例类型不能为空', trigger: 'change' }
        ],
        imageRef: [
          { required: true, validator: this.validImageRule, message: '请选择镜像', trigger: 'change' }
        ],
        volume_size: [
          { required: true, validator: this.validVolumeSizeRule, message: '卷大小不能为空', trigger: 'blur' }
        ]
      },
      currentFormType: 'info',
      currentFormTypeStep: 0,
      formTypeList: [
        { value: 'info', label: '详情', required: true },
        { value: 'source', label: '源', required: true },
        { value: 'flavor', label: '实例类型', required: true },
        { value: 'network', label: '网络', required: true },
        { value: 'port', label: '网络接口' },
        { value: 'security_group', label: '安全组' },
        { value: 'keypair', label: '密钥对' }
        // { value: 'config', label: '配置' },
        // { value: 'server_group', label: '服务器组' }
      ],

      // 镜像
      selected_image_data: [],
      selected_image_columns: [
        {
          title: '镜像名称',
          align: 'center',
          minWidth: 150,
          key: 'name'
        },
        {
          title: '大小',
          minWidth: 130,
          align: 'center',
          render: (h, params) => {
            const KB = 1024
            const MB = KB * 1024
            const GB = MB * 1024
            let size = params.row.size
            if (size) {
              if (size >= GB) {
                size = (size / GB).toFixed(2) + ' GB'
              } else if (size >= MB) {
                size = (size / MB).toFixed(2) + ' MB'
              } else if (size >= KB) {
                size = (size / KB).toFixed(2) + ' KB'
              } else {
                size = size + ' 字节'
              }
            }
            return h('span', size)
          }
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 150,
          key: 'disk_format'
        },
        {
          title: '可见性',
          align: 'center',
          minWidth: 80,
          key: 'visibility',
          render: (h, params) => {
            if (params.row.visibility === 'public') {
              return h('div', '公有')
            } else if (params.row.visibility === 'private') {
              return h('div', '私有')
            } else if (params.row.visibility === 'shared') {
              return h('div', '共享的')
            } else {
              return h('div', params.row.visibility)
            }
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.imageList.push(params.row)
                  this.selected_image_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      imageOptionalLoading: false,
      imageList: [],
      image_optional_columns: [
        {
          title: '镜像名称',
          align: 'center',
          minWidth: 150,
          key: 'name'
        },
        {
          title: '大小',
          minWidth: 130,
          align: 'center',
          render: (h, params) => {
            const KB = 1024
            const MB = KB * 1024
            const GB = MB * 1024
            let size = params.row.size
            if (size) {
              if (size >= GB) {
                size = (size / GB).toFixed(2) + ' GB'
              } else if (size >= MB) {
                size = (size / MB).toFixed(2) + ' MB'
              } else if (size >= KB) {
                size = (size / KB).toFixed(2) + ' KB'
              } else {
                size = size + ' 字节'
              }
            }
            return h('span', size)
          }
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 150,
          key: 'disk_format'
        },
        {
          title: '可见性',
          align: 'center',
          minWidth: 80,
          key: 'visibility',
          render: (h, params) => {
            if (params.row.visibility === 'public') {
              return h('div', '公有')
            } else if (params.row.visibility === 'private') {
              return h('div', '私有')
            } else if (params.row.visibility === 'shared') {
              return h('div', '共享的')
            } else {
              return h('div', params.row.visibility)
            }
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.imageList = this.imageList.concat(this.selected_image_data)
                  this.selected_image_data = [params.row]
                  this.imageList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 卷
      selected_volume_data: [],
      selected_volume_columns: [
        {
          title: '卷名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '大小',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'size',
          render: (h, params) => {
            return h('span', params.row.size + ' GiB')
          }
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 130,
          tooltip: true,
          key: 'volume_type'
        },
        {
          title: '可用域',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'availability_zone'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.volumeList.push(params.row)
                  this.selected_volume_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      volumeOptionalLoading: false,
      volumeList: [],
      volume_optional_columns: [
        {
          title: '卷名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '大小',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'size',
          render: (h, params) => {
            return h('span', params.row.size + ' GiB')
          }
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 130,
          tooltip: true,
          key: 'volume_type'
        },
        {
          title: '可用域',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'availability_zone'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.volumeList = this.volumeList.concat(this.selected_volume_data)
                  this.selected_volume_data = [params.row]
                  this.volumeList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 卷快照
      selected_volume_snapshot_data: [],
      selected_volume_snapshot_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          key: 'description',
          tooltip: true
        },
        {
          title: '大小',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'size',
          render: (h, params) => {
            return h('span', params.row.size + ' GiB')
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'creating' ? 'warning'
              : status === 'available' ? 'success'
                : status === 'backing-up' ? 'warning'
                  : status === 'deleting' ? 'warning'
                    : status === 'error' ? 'error'
                      : status === 'deleted' ? 'error'
                        : status === 'unmanaging' ? 'warning'
                          : status === 'restoring' ? 'warning'
                            : status === 'error_deleting' ? 'error'
                              : 'warning'
            let text = status === 'creating' ? '创建中'
              : status === 'available' ? '可用'
                : status === 'backing-up' ? '正在备份'
                  : status === 'deleting' ? '删除中'
                    : status === 'error' ? '错误'
                      : status === 'deleted' ? '已删除'
                        : status === 'unmanaging' ? '非管理状态'
                          : status === 'restoring' ? '正在恢复卷'
                            : status === 'error_deleting' ? '删除时出错'
                              : status
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: '卷',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'volume_id'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.volumeSnapshotList.push(params.row)
                  this.selected_volume_snapshot_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      volumeSnapshotOptionalLoading: false,
      volumeSnapshotList: [],
      volume_snapshot_optional_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          key: 'description',
          tooltip: true
        },
        {
          title: '大小',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'size',
          render: (h, params) => {
            return h('span', params.row.size + ' GiB')
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'creating' ? 'warning'
              : status === 'available' ? 'success'
                : status === 'backing-up' ? 'warning'
                  : status === 'deleting' ? 'warning'
                    : status === 'error' ? 'error'
                      : status === 'deleted' ? 'error'
                        : status === 'unmanaging' ? 'warning'
                          : status === 'restoring' ? 'warning'
                            : status === 'error_deleting' ? 'error'
                              : 'warning'
            let text = status === 'creating' ? '创建中'
              : status === 'available' ? '可用'
                : status === 'backing-up' ? '正在备份'
                  : status === 'deleting' ? '删除中'
                    : status === 'error' ? '错误'
                      : status === 'deleted' ? '已删除'
                        : status === 'unmanaging' ? '非管理状态'
                          : status === 'restoring' ? '正在恢复卷'
                            : status === 'error_deleting' ? '删除时出错'
                              : status
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: '卷',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'volume_id'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.volumeSnapshotList = this.volumeSnapshotList.concat(this.selected_volume_snapshot_data)
                  this.selected_volume_snapshot_data = [params.row]
                  this.volumeSnapshotList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 实例类型
      selected_flavor_data: [],
      selected_flavor_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: 'VCPU 数量',
          align: 'center',
          minWidth: 100,
          key: 'vcpus'
        },
        {
          title: '内存',
          align: 'center',
          minWidth: 100,
          key: 'ram',
          render: (h, params) => {
            let size = params.row.ram
            return h('span', size + ' MB')
          }
        },
        {
          title: '根磁盘',
          align: 'center',
          minWidth: 100,
          key: 'disk',
          render: (h, params) => {
            return h('div', params.row.disk + ' GB')
          }
        },
        {
          title: '临时磁盘',
          align: 'center',
          minWidth: 100,
          key: 'OS-FLV-EXT-DATA:ephemeral',
          render: (h, params) => {
            return h('div', params.row['OS-FLV-EXT-DATA:ephemeral'] + ' GB')
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.flavorList.push(params.row)
                  this.selected_flavor_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      flavorOptionalLoading: false,
      flavorList: [],
      flavor_optional_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: 'VCPU 数量',
          align: 'center',
          minWidth: 100,
          key: 'vcpus'
        },
        {
          title: '内存',
          align: 'center',
          minWidth: 100,
          key: 'ram',
          render: (h, params) => {
            let size = params.row.ram
            return h('span', size + ' MB')
          }
        },
        {
          title: '根磁盘',
          align: 'center',
          minWidth: 100,
          key: 'disk',
          render: (h, params) => {
            return h('div', params.row.disk + ' GB')
          }
        },
        {
          title: '临时磁盘',
          align: 'center',
          minWidth: 100,
          key: 'OS-FLV-EXT-DATA:ephemeral',
          render: (h, params) => {
            return h('div', params.row['OS-FLV-EXT-DATA:ephemeral'] + ' GB')
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.flavorList = this.flavorList.concat(this.selected_flavor_data)
                  this.selected_flavor_data = [params.row]
                  this.flavorList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 网络
      selected_network_data: [],
      selected_network_columns: [
        {
          title: '网络名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        // {
        //   title: '已连接的子网',
        //   align: 'center',
        //   minWidth: 230,
        //   render: (h, params) => {
        //     const subnets = params.row.subnets
        //     let result = []
        //     for (let i in subnets) {
        //       result.push(h('p', subnets[i].name + ': ' + subnets[i].cidr))
        //     }
        //     return h('div', result)
        //   }
        // },
        {
          title: '外部网络',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            let res = '是'
            let color = '#19be6b'
            if (!params.row['router:external']) {
              res = '否'
              color = '#ed4014'
            }
            return h('span', {
              style: {
                color: color
              }
            }, res)
          }
        },
        {
          title: '外部网络',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let res = '是'
            let color = '#19be6b'
            if (!params.row['router:external']) {
              res = '否'
              color = '#2aa7ed'
            }
            return h('span', {
              style: {
                color: color
              }
            }, res)
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'ACTIVE' ? 'success'
              : status === 'BUILD' ? 'warning'
                : status === 'DOWN' || status === 'ERROR' ? 'error'
                  : 'warning'
            let text = status === 'ACTIVE' ? '运行'
              : status === 'BUILD' ? '构建中'
                : status === 'DOWN' ? 'Down'
                  : status === 'ERROR' ? '错误'
                    : '未知'
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          tooltip: true,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.networkList.push(params.row)
                  this.selected_network_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      networkOptionalLoading: false,
      networkList: [],
      network_optional_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        // {
        //   title: '已连接的子网',
        //   align: 'center',
        //   minWidth: 230,
        //   render: (h, params) => {
        //     const subnets = params.row.subnets
        //     let result = []
        //     for (let i in subnets) {
        //       result.push(h('p', subnets[i].name + ': ' + subnets[i].cidr))
        //     }
        //     return h('div', result)
        //   }
        // },
        {
          title: '外部网络',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let res = '是'
            let color = '#19be6b'
            if (!params.row['router:external']) {
              res = '否'
              color = '#2aa7ed'
            }
            return h('span', {
              style: {
                color: color
              }
            }, res)
          }
        },
        {
          title: '管理状态',
          align: 'center',
          minWidth: 80,
          key: 'admin_state_up',
          render: (h, params) => {
            let res = '是'
            if (!params.row.admin_state_up) {
              res = '否'
            }
            return h('span', res)
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'ACTIVE' ? 'success'
              : status === 'BUILD' ? 'warning'
                : status === 'DOWN' || status === 'ERROR' ? 'error'
                  : 'warning'
            let text = status === 'ACTIVE' ? '运行'
              : status === 'BUILD' ? '构建中'
                : status === 'DOWN' ? 'Down'
                  : status === 'ERROR' ? '错误'
                    : '未知'
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.selected_network_data.push(params.row)
                  this.networkList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 端口（网络接口）
      selected_port_data: [],
      selected_port_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 130,
          tooltip: true,
          render: (h, params) => {
            let name = params.row.name
            if (!name) {
              name = '无'
            }
            return h('div', name)
          }
        },
        {
          title: '固定IP',
          align: 'center',
          minWidth: 150,
          tooltip: true,
          render: (h, params) => {
            const fixedIps = params.row.fixed_ips
            let result = []
            for (let i in fixedIps) {
              result.push(h('p', fixedIps[i].ip_address))
            }
            return h('div', result)
          }
        },
        {
          title: '所属网络',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'network_id'
        },
        {
          title: '管理状态',
          align: 'center',
          minWidth: 80,
          tooltip: true,
          key: 'admin_state_up',
          render: (h, params) => {
            let res = '是'
            if (!params.row.admin_state_up) {
              res = '否'
            }
            return h('span', res)
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'ACTIVE' ? 'success'
              : status === 'DOWN' || status === 'BUILD' ? 'warning'
                : status === 'ERROR' ? 'error'
                  : 'warning'
            let text = status === 'ACTIVE' ? '运行'
              : status === 'BUILD' ? '构建中'
                : status === 'DOWN' ? 'Down'
                  : status === 'ERROR' ? '错误'
                    : status
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.portList.push(params.row)
                  this.selected_port_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      portOptionalLoading: false,
      portList: [],
      port_optional_columns: [
        {
          title: '名称',
          align: 'center',
          minWidth: 130,
          tooltip: true,
          render: (h, params) => {
            let name = params.row.name
            if (!name) {
              name = '无'
            }
            return h('div', name)
          }
        },
        {
          title: '固定IP',
          align: 'center',
          minWidth: 150,
          tooltip: true,
          render: (h, params) => {
            const fixedIps = params.row.fixed_ips
            let result = []
            for (let i in fixedIps) {
              result.push(h('p', fixedIps[i].ip_address))
            }
            return h('div', result)
          }
        },
        {
          title: '所属网络',
          align: 'center',
          minWidth: 120,
          tooltip: true,
          key: 'network_id'
        },
        {
          title: '管理状态',
          align: 'center',
          minWidth: 80,
          tooltip: true,
          key: 'admin_state_up',
          render: (h, params) => {
            let res = '是'
            if (!params.row.admin_state_up) {
              res = '否'
            }
            return h('span', res)
          }
        },
        {
          title: '状态',
          align: 'center',
          minWidth: 150,
          render: (h, params) => {
            let status = params.row.status
            let color = status === 'ACTIVE' ? 'success'
              : status === 'DOWN' || status === 'BUILD' ? 'warning'
                : status === 'ERROR' ? 'error'
                  : 'warning'
            let text = status === 'ACTIVE' ? '运行'
              : status === 'BUILD' ? '构建中'
                : status === 'DOWN' ? 'Down'
                  : status === 'ERROR' ? '错误'
                    : status
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.selected_port_data.push(params.row)
                  this.portList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 安全组
      selected_security_group_data: [],
      selected_security_group_columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(SecurityGroupRuleList, {
              props: {
                security_group_id: params.row.id
              }
            })
          }
        },
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          key: 'description'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.securityGroupList.push(params.row)
                  this.selected_security_group_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      securityGroupOptionalLoading: false,
      securityGroupList: [],
      security_group_optional_columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(SecurityGroupRuleList, {
              props: {
                security_group_id: params.row.id
              }
            })
          }
        },
        {
          title: '名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '描述',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          key: 'description'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.selected_security_group_data.push(params.row)
                  this.securityGroupList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ],

      // 密钥对
      selected_key_pair_data: [],
      selected_key_pair_columns: [
        {
          title: '密钥对名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'type'
        },
        {
          title: '指纹',
          align: 'center',
          minWidth: 300,
          tooltip: true,
          key: 'fingerprint'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.keyPairList.push(params.row)
                  this.selected_key_pair_data.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-down'
                }
              })
            ])
          }
        }
      ],
      keyPairOptionalLoading: false,
      keyPairList: [],
      key_pair_optional_columns: [
        {
          title: '密钥对名称',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'name'
        },
        {
          title: '类型',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'type'
        },
        {
          title: '指纹',
          align: 'center',
          minWidth: 300,
          tooltip: true,
          key: 'fingerprint'
        },
        {
          title: ' ',
          align: 'center',
          minWidth: 70,
          render: (h, params) => {
            return h('Button', {
              on: {
                click: () => {
                  this.keyPairList = this.keyPairList.concat(this.selected_key_pair_data)
                  this.selected_key_pair_data = [params.row]
                  this.keyPairList.splice(params.row._index, 1)
                }
              }
            }, [
              h('Icon', {
                props: {
                  type: 'md-arrow-round-up'
                }
              })
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    this.openModal()
  },
  methods: {
    // 打开编辑框
    openModal () {
      this.formReset()
      this.$refs.Quota.getData()
      this.getAllImageList()
      this.getAllFlavorList()
      this.getVolumeList()
      this.getVolumeSnapshotList()
      this.getNetworkListData()
      this.getPortList()
      this.getSecurityGroupListData()
      this.getKeyPairListData()
      this.getAvailabilityZoneListData()
    },
    // 获取所有镜像列表
    getAllImageList () {
      this.imageOptionalLoading = true
      getPrivateCloudAllImage().then(res => {
        this.imageList = res.data
        this.imageOptionalLoading = false
      }).catch(res => {
        this.imageOptionalLoading = false
        this.$Notice.error({
          title: '获取镜像列表失败！'
        })
      })
    },
    // 获取卷列表
    getVolumeList () {
      this.volumeOptionalLoading = true
      getPrivateCloudAllVolume().then(res => {
        this.volumeList = []
        for (let i in res.data) {
          if (res.data[i].status === 'available' && res.data[i].bootable === 'true') {
            this.volumeList.push(res.data[i])
          }
        }
        this.volumeOptionalLoading = false
      }).catch(res => {
        this.volumeOptionalLoading = false
        this.$Notice.error({
          title: '获取卷列表失败！'
        })
      })
    },
    // 获取卷快照列表
    getVolumeSnapshotList () {
      this.volumeSnapshotOptionalLoading = true
      getPrivateCloudAllVolumeSnapshot().then(res => {
        this.volumeSnapshotList = res.data
        this.volumeSnapshotOptionalLoading = false
      }).catch(res => {
        this.volumeSnapshotOptionalLoading = false
        this.$Notice.error({
          title: '获取卷快照列表失败！'
        })
      })
    },
    // 获取所有实例类型列表
    getAllFlavorList () {
      this.flavorOptionalLoading = true
      getPrivateCloudAllFlavor().then(res => {
        this.flavorList = res.data
        this.flavorOptionalLoading = false
      }).catch(res => {
        this.flavorOptionalLoading = false
        this.$Notice.error({
          title: '获取实例类型列表失败！'
        })
      })
    },
    // 获取网络列表
    getNetworkListData () {
      this.networkOptionalLoading = true
      getPrivateCloudAllNetwork().then(res => {
        this.networkList = res.data
        this.networkOptionalLoading = false
      }).catch(res => {
        this.networkOptionalLoading = false
        this.$Notice.error({
          title: '获取网络列表失败！'
        })
      })
    },
    // 获取端口（网络接口）列表
    getPortList () {
      this.portOptionalLoading = true
      getPrivateCloudAllPort().then(res => {
        this.portList = []
        for (let i in res.data) {
          if (res.data[i].status === 'DOWN') {
            this.portList.push(res.data[i])
          }
        }
        this.portOptionalLoading = false
      }).catch(res => {
        this.portOptionalLoading = false
        this.$Notice.error({
          title: '获取端口（网络接口）列表失败！'
        })
      })
    },
    // 获取安全组列表
    getSecurityGroupListData () {
      this.securityGroupOptionalLoading = true
      getPrivateCloudAllSecurityGroup().then(res => {
        this.securityGroupList = res.data
        for (let i in res.data) {
          if (res.data[i].name === 'default') {
            this.selected_security_group_data.push(res.data[i])
            this.securityGroupList.splice(i, 1)
            break
          }
        }
        this.securityGroupOptionalLoading = false
      }).catch(res => {
        this.securityGroupOptionalLoading = false
        this.$Notice.error({
          title: '获取安全组列表失败！'
        })
      })
    },
    // 获取可用域列表
    getAvailabilityZoneListData () {
      getPrivateCloudAvailabilityZones().then(res => {
        this.availabilityZoneList = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取可用域列表失败！'
        })
      })
    },
    // 获取密钥对列表
    getKeyPairListData () {
      this.keyPairOptionalLoading = true
      getPrivateCloudAllKeyPair().then(res => {
        this.keyPairList = res.data
        this.keyPairOptionalLoading = false
      }).catch(res => {
        this.keyPairOptionalLoading = false
        this.$Notice.error({
          title: '获取密钥对列表失败！'
        })
      })
    },
    // 编辑表单提交
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            name: this.changeForm.name,
            availability_zone: this.changeForm.availability_zone,
            block_device_mapping_v2: [
              {
                boot_index: 0,
                source_type: this.changeForm.source_type,
                delete_on_termination: this.changeForm.delete_on_termination
              }
            ],
            networks: []
          }
          if (this.changeForm.source_type === 'image') {
            if (!this.selected_image_data.length) {
              this.currentFormTypeStep = 1
              this.currentFormType = 'source'
              this.$Notice.warning({
                title: '提交失败，请选择一个镜像！'
              })
              return
            } else {
              reqData.block_device_mapping_v2[0].destination_type = 'volume'
              reqData.block_device_mapping_v2[0].uuid = this.selected_image_data[0].id
              reqData.imageRef = this.selected_image_data[0].id
              if (this.changeForm.create_new_volume) {
                reqData.block_device_mapping_v2[0].volume_size = this.changeForm.volume_size
              } else {
                reqData.block_device_mapping_v2[0].no_device = true
              }
            }
          }
          if (this.changeForm.source_type === 'volume') {
            if (!this.selected_volume_data.length) {
              this.currentFormTypeStep = 1
              this.currentFormType = 'source'
              this.$Notice.warning({
                title: '提交失败，请选择一个卷！'
              })
              return
            } else {
              reqData.block_device_mapping_v2[0].destination_type = 'volume'
              reqData.block_device_mapping_v2[0].uuid = this.selected_volume_data[0].id
            }
          }
          if (this.changeForm.source_type === 'snapshot') {
            if (!this.selected_volume_snapshot_data.length) {
              this.currentFormTypeStep = 1
              this.currentFormType = 'source'
              this.$Notice.warning({
                title: '提交失败，请选择一个卷快照！'
              })
              return
            } else {
              reqData.block_device_mapping_v2[0].destination_type = 'volume'
              reqData.block_device_mapping_v2[0].uuid = this.selected_volume_snapshot_data[0].id
            }
          }
          if (!this.selected_flavor_data.length) {
            this.currentFormTypeStep = 2
            this.currentFormType = 'flavor'
            this.$Notice.warning({
              title: '提交失败，请选择一个实例类型！'
            })
            return
          } else {
            reqData.flavorRef = this.selected_flavor_data[0].id
          }

          if (!this.selected_network_data.length && !this.selected_port_data.length) {
            this.currentFormTypeStep = 3
            this.currentFormType = 'network'
            this.$Notice.warning({
              title: '提交失败！',
              desc: '请至少选择一个网络或者网络接口。'
            })
            return
          } else {
            for (let v in this.selected_network_data) {
              reqData.networks.push({ uuid: this.selected_network_data[v].id })
            }
            for (let v in this.selected_port_data) {
              reqData.networks.push({ port: this.selected_port_data[v].id })
            }
          }
          if (this.selected_security_group_data.length) {
            reqData.security_groups = []
            for (let v in this.selected_security_group_data) {
              reqData.security_groups.push({ name: this.selected_security_group_data[v].id })
            }
          }
          if (this.selected_key_pair_data.length) {
            reqData.key_name = this.selected_key_pair_data[0].name
          }
          this.changeLoading = true
          this.errorMsgShow = false
          changePrivateCloudServer(reqData, this.changeForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$router.push({'name': 'server'})
            this.formReset('changeForm')
            this.changeLoading = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应'
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          if (!this.changeForm.name || !this.changeForm.availability_zone) {
            this.currentFormTypeStep = 0
            this.currentFormType = 'info'
          } else if (!this.changeForm.source_type) {
            this.currentFormTypeStep = 1
            this.currentFormType = 'source'
          } else if (this.changeForm.source_type === 'image' || this.changeForm.source_type === 'server_snapshot') {
            if (this.changeForm.create_new_volume && this.changeForm.volume_size === null) {
              this.currentFormTypeStep = 1
              this.currentFormType = 'source'
            }
          }
          this.$Notice.warning({
            title: '提交失败，请检查输入框！'
          })
        }
      })
    },
    // 通用重置表单
    formReset () {
      this.changeForm = {
        id: '',
        name: '',
        source_type: 'image',
        availability_zone: '',
        imageRef: '',
        create_new_volume: true,
        volume_size: 5,
        delete_on_termination: false,
        flavor: ''
      }
      this.selected_image_data = []
      this.selected_volume_data = []
      this.selected_volume_snapshot_data = []
      this.selected_flavor_data = []
      this.selected_network_data = []
      this.selected_port_data = []
      this.selected_security_group_data = []
      this.selected_key_pair_data = []
    },
    // 关闭编辑表单触发
    changeModalClose () {
      this.formReset('changeForm')
    },
    // 镜像选择校验
    validImageRule (rule, value, callback) {
      if (this.changeForm.source_type === 'image') {
        if (!value) {
          callback(new Error())
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    // 校验卷大小
    validVolumeSizeRule (rule, value, callback) {
      if (this.changeForm.create_new_volume === true && (this.changeForm.source_type === 'image' || this.changeForm.source_type === 'server_snapshot')) {
        if (!value) {
          callback(new Error())
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
  }
}
</script>

<style scoped>
  .form-item {
    padding-left: 5px;
    margin-right: 40px;
    list-style-type: none;
    cursor: pointer;
    line-height: 30px;
    margin-bottom: 10px;
    font-size: 15px;
  }
  .form-item-active {
    color: #fff !important;
    background-color: #001529 !important;
  }
  .form-item:hover, .form-item:visited {
    color: #515a6e;
    background-color: rgb(243, 243, 243);
  }
</style>
